/**
 * Utilities for interacting with lists of collaborators
 * @todo What is the purpose of this?  Why is it even a class since everything
 *   is practically static.  It seems to be used in one place, which is the
 *   invite view.  I'm not even sure if collaborator means "user who is
 *   collaborating". This should be moved closer to the components that use this.
 */
class CollaboratorService {
  getCollaboratorIdsMap(collaborators) {
    const {
      accounts,
      teams,
    } = collaborators;

    const _accounts = accounts || [];
    const _teams = teams || [];

    return {
      /* eslint no-param-reassign: ["error", { "props": false }] */
      teams: _teams.reduce((map, item) => {
        map[item.team.id] = true;
        return map;
      }, {}),
      accounts: _accounts.reduce((map, item) => {
        map[item.account.accountId] = true;
        return map;
      }, {}),
    };
  }

  getCollaboratorByUserId(collaborators, accountId) {
    return collaborators.accounts?.find((item) => item.account.accountId === accountId);
  }

  getCollaboratorTeamByAccountId(collaborators, teams, accountId) {
    const { teams: collaboratorsTeams = [] } = collaborators;
    let collaboratorTeam = null;

    teams.some((team) => {
      const collaborator =
        team.accountSummaries &&
        team.accountSummaries.find((item) => item.accountId === accountId);

      if (collaborator) {
        collaboratorTeam = collaboratorsTeams.find((collaboratorsTeam) =>
          team.teamId === collaboratorsTeam.team.id
        );
        return true;
      }

      return false;
    });

    return collaboratorTeam;
  }
}

const collaboratorService = new CollaboratorService();

export default collaboratorService;
